__turbopack_context__.v({
  "CardList": "CmIlma_CardList",
  "CardListWrapper": "CmIlma_CardListWrapper",
  "Container": "CmIlma_Container",
  "NoHitsText": "CmIlma_NoHitsText",
  "NoHitsTitle": "CmIlma_NoHitsTitle",
  "NoHitsWrapper": "CmIlma_NoHitsWrapper",
  "ResultText": "CmIlma_ResultText",
  "Root": "CmIlma_Root",
  "Show": "CmIlma_Show",
});
